import { UseCase } from "../../useCase"
import { B2BRepository } from "../../../repositories/b2bRepository"
import { UpdateB2BImageRequest } from "./request"
import { UpdateB2BImageResponse } from "./response"

export class UpdateB2BImageUseCase implements UseCase<UpdateB2BImageRequest, UpdateB2BImageResponse> {
	private _repository

	constructor({ B2BRepository }: { B2BRepository: B2BRepository }) {
		this._repository = B2BRepository
	}

	exec({ imageName, files }: UpdateB2BImageRequest) {
		return this._repository.updateB2BImage(imageName, files)
	}
}
